import React from "react";

import "./styles.css";

// Import unit-golf component
import UnitGolf from "./unit-golf/UnitGolf.js";
import "./unit-golf/UnitGolf.css";

export default function App() {
  return (
    <div className="App">
      <div className="top"></div>

      <div className="content">
        <h1>unit golf</h1>
        <UnitGolf></UnitGolf>
        <div className="infoText">You can click the unit to copy it!</div>
      </div>
      <footer className="footer">
        <a
          href="https://www.flaticon.com/free-icons/measure"
          title="measure icons"
        >
          Measure icons created by Smashicons - Flaticon
        </a>
      </footer>
    </div>
  );
}
